import { Table } from "antd";
import type { AnyObject } from "antd/es/_util/type";
import type { SorterResult } from "antd/es/table/interface";
import { PaginationComponent } from "~Common/Pagination/PaginationComponent";
import type { UpsertConductData } from "~pages/Conducts/types/upsertConductData.ts";
import useConductTableColumns from "../hooks/useConductTableColumns.tsx";

type Props = {
  data: Array<AnyObject>;
  isLoading: boolean;
  pagination: {
    currentPage: number;
    pageSize: number;
    offset: number;
    handlePaginationChange: (current: number, size: number) => void;
    pageSizeOptions: Array<number>;
  };
  onConductDelete: (conductId: string) => void;
  onConductUpsert: (upsertData: UpsertConductData) => void;
  isUpsertInProcess: boolean;
  onSortChange: (sortBy: string) => void;
};
const ConductList = ({
  data,
  isLoading,
  pagination: { currentPage, pageSize, handlePaginationChange, offset, pageSizeOptions },
  onConductDelete,
  onConductUpsert,
  isUpsertInProcess,
  onSortChange,
}: Props) => {
  const columns = useConductTableColumns(onConductDelete, onConductUpsert, isUpsertInProcess);

  const handleTableChange = (_pagination: unknown, _filters: unknown, sorter: SorterResult<AnyObject> | SorterResult<AnyObject>[]) => {
    if (!Array.isArray(sorter) && onSortChange) {
      if (sorter.column) {
        onSortChange(`${sorter.order === "ascend" ? "" : "-"}${sorter.column.dataIndex as string}`);
      } else {
        onSortChange("-added");
      }
    }
  };

  return (
    <div>
      <Table
        dataSource={data}
        loading={isLoading}
        size={"small"}
        rowKey={({ conductId }) => conductId}
        onChange={handleTableChange}
        pagination={{
          current: currentPage,
          defaultPageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions,
          showQuickJumper: false,
          total: offset + data.length + 1,
          position: ["bottomCenter"],
          onChange: handlePaginationChange,
          showTotal: (total, range) => <PaginationComponent pageNumber={currentPage} pageSize={pageSize} total={total} range={range} />,
        }}
        columns={columns}
      />
    </div>
  );
};

export default ConductList;
